import { type ReferenceFieldProps, SelectField, useGetList } from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

export const ClientAppField = (
  props: Pick<ReferenceFieldProps, "source" | "sortable" | "label">,
) => {
  const { isPending, data } = useGetList(MODULE_NAMES.CLIENT_APPS);

  return (
    <SelectField
      source={props.source}
      sortable={props.sortable}
      isPending={isPending}
      optionValue="@id"
      optionText="title"
      label={props.label}
      choices={data ?? []}
    />
  );
};
